import {
  useDispatch
} from 'react-redux'
import { useEffect, useState } from 'react'
import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

let fromLocalStorage1 = false, company1 = ''
const SpinnerComponent = () => {
  const dispatch = useDispatch()
  const [logo, setLogo] = useState(require('@src/assets/images/logo/Loading-Logo.png').default)

  const getAllData = createAsyncThunk('driverProfile/GetTableSummary', async (params) => {

    const response = await axios.post('https://api.zasway.com:8443/Booking/GetCompanyDetails', params, { mode: 'cors' })
  
    return response.data
  })
  const getLogo = createAsyncThunk('driverProfile/GetTableSummary', async (params) => {

    const response = await axios.post('https://api.zasway.com:8443/Common/GetSystemLogo', params, { mode: 'cors' })
  
    return response.data
  })
  
  const GetCompanyDetails = async () => {
     
    let ShortName = '', system = '', response = '', company = ''
    let fromLocalStorage = false
    if (JSON.parse(localStorage.getItem('companyID')) !== null && JSON.parse(localStorage.getItem('companyID') > 0)) {
       
      fromLocalStorage = true
      fromLocalStorage1 = true
      // if (JSON.parse(localStorage.getItem('companyID')) === 10005 || JSON.parse(localStorage.getItem('companyID')) === 10006) {
      //   if (JSON.parse(localStorage.getItem('staffRoleID')) === 'Passenger') {
      //     logo = logo3
      //   } else {
    
      //     logo = logo2
      //   }
      // } else {
      //   if (JSON.parse(localStorage.getItem('staffRoleID')) === 'Passenger') {
      //     logo = logo4
      //   } else {
    
      //     logo = logo1
      //   }
      // }
    } else {
       
      fromLocalStorage = false
      fromLocalStorage1 = false
      const URLString = window.location
      if (URLString?.search?.split("?") !== undefined) {
        const splitURL = URLString?.search?.split("?")
         ShortName = splitURL[1]
         if (ShortName) {
          if (ShortName?.includes('PassApp')) {
            system = 'Passenger'
            ShortName = ShortName.split('_PassApp')[0]
            // if (ShortName.split('_PassApp')[0] === 'CharChauf') {
            //   logo = logo3
            // } else {
            //   logo = logo4
            // }
          }  else {
            // if (ShortName !== "" && ShortName === 'CharChauf') {
            //   logo = logo2
            // } else {
            //   logo = logo1
            // }
            system = 'Admin'
          }
         } else {
          ShortName = 'UKCB'
          system = 'Admin'
         }
        
         response = await dispatch(
          getAllData(
            {
              companyShortName: ShortName
            }
          ))
            
          company = response?.payload
          company1 = response?.payload
          console.log(logo, fromLocalStorage, system, response, company)
      }

    }
   const response1 = await dispatch(
    getLogo(
      {
        userType: fromLocalStorage === true ? JSON.parse(localStorage.getItem('staffRoleID')) : system,
        companyID: fromLocalStorage === true ? JSON.parse(localStorage.getItem('companyID')) : company.id
      }
    ))
      
    if (response1.payload !== undefined && response1.payload !== null) {
      const logoPath = response1.payload.navBarLogo ? require(`@src/assets/images/logo/${response1.payload.mainLogo}`).default : require('@src/assets/images/logo/Loading-Logo.png').default

      setLogo(logoPath)
    }
    console.log(response1)
  }
 useEffect(() => {
  const queryPart = window?.location?.href?.split('?')[1]
    const keyBeforeColon = queryPart?.split(':')[0]
    if (keyBeforeColon !== "success" && keyBeforeColon !== "error") {

 GetCompanyDetails()
  }
  }, [])
   
  console.log(fromLocalStorage1, company1)
  return (
    // fromLocalStorage1 === true && parseJSON(localStorage.getItem('companyID')) === 1 ? (
    //   <div className='fallback-spinner app-loader'>
    //     <img className='fallback-logo' src={logo} alt='logo' />
    //     <div className='loading'>
    //       <div className='effect-1 effects'></div>
    //       <div className='effect-2 effects'></div>
    //       <div className='effect-3 effects'></div>
    //     </div>
    //   </div>
    // ) : (fromLocalStorage1 === false && company1.id === 1 ? (
    //   <div className='fallback-spinner app-loader'>
    //     <img className='fallback-logo' src={logo} alt='logo' />
    //     <div className='loading'>
    //       <div className='effect-1 effects'></div>
    //       <div className='effect-2 effects'></div>
    //       <div className='effect-3 effects'></div>
    //     </div>
    //   </div>
    // ) : <div className='chariot-fallback-spinner chariot-app-loader'>
    //     <img className='fallback-logo' src={logo} alt='logo' />
    //     <div className='loading'>
    //       <div className='effect-1 effects'></div>
    //       <div className='effect-2 effects'></div>
    //       <div className='effect-3 effects'></div>
    //     </div>
    //   </div>
    // )
    window.location?.search !== "" && window.location?.search?.split("?") !== undefined && window.location?.search?.split("?")[1] !== undefined) ? (

     window.location?.search?.split("?")[1] === 'CharChauf' ||  window.location?.search?.split("?")[1] === 'CharChauf_PassApp' || JSON.parse(localStorage.getItem('companyID')) === 10005 ? (
   
         
    <div className='chariot-fallback-spinner chariot-app-loader'>
    <img className='fallback-logo' src={logo} alt='logo' />
    <div className='loading'>
      <div className='effect-1 effects'></div>
      <div className='effect-2 effects'></div>
      <div className='effect-3 effects'></div>
    </div>
  </div>) : (<div className='fallback-spinner app-loader'>
          <img className='fallback-logo' src={logo} alt='logo' />
          <div className='loading'>
            <div className='effect-1 effects'></div>
            <div className='effect-2 effects'></div>
            <div className='effect-3 effects'></div>
          </div>
        </div>)
  ) : (JSON.parse(localStorage.getItem('companyID')) === 10005 ? (
    <div className='chariot-fallback-spinner chariot-app-loader'>
    <img className='fallback-logo' src={logo} alt='logo' />
    <div className='loading'>
      <div className='effect-1 effects'></div>
      <div className='effect-2 effects'></div>
      <div className='effect-3 effects'></div>
    </div>
  </div>) : (
   
   <div className='fallback-spinner app-loader'>
   <img className='fallback-logo' src={logo} alt='logo' />
   <div className='loading'>
     <div className='effect-1 effects'></div>
     <div className='effect-2 effects'></div>
     <div className='effect-3 effects'></div>
   </div>
 </div>))
}

export default SpinnerComponent
